/**
 * 通用功能集合
 *
 * 提供常用的页面操作功能，包括页面刷新、滚动控制、路径获取等。
 * 这些功能在多个页面和组件中都会用到，统一封装便于复用。
 *
 *
 */

import useAppStore from '@/store/app.store';

export function useCommon() {
  const appStore = useAppStore();

  /**
   * 刷新当前页面
   */
  const refresh = () => {
    appStore.reloadPage();
  };

  /**
   * 滚动到页面顶部
   * 查找主内容区域并将其滚动位置重置为顶部
   */
  const scrollToTop = () => {
    const scrollContainer = document.getElementById('app-main');

    if (scrollContainer) {
      scrollContainer.scrollTop = 0;
    }
  };

  /**
   * 平滑滚动到页面顶部
   * 使用 smooth 行为实现平滑滚动效果
   */
  const smoothScrollToTop = () => {
    const scrollContainer = document.getElementById('app-main');

    if (scrollContainer) {
      scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };

  /**
   * 滚动到指定位置
   * @param top 目标滚动位置（像素）
   * @param smooth 是否使用平滑滚动
   */
  const scrollTo = (top: number, smooth: boolean = false) => {
    const scrollContainer = document.getElementById('app-main');

    if (scrollContainer) {
      scrollContainer.scrollTo({
        top,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }
  };

  return {
    refresh,
    scrollTo,
    scrollToTop,
    smoothScrollToTop
  };
}
